<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="8" md="4" class="my-0 py-0">
          <buscar-empleado :value.sync="empSearch"></buscar-empleado>
        </v-col>
      </v-row>
      <v-row >
        <v-col cols="12" md="6">
          <v-card>
            <v-card-text class="py-2">
              <v-row>
                <v-col cols="12" class="py-0">
                  <span v-if="empSearch"> {{empSearch.nombreCompleto}} </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <span v-for="(dia, index) in diasOri" :key="index">
                    <v-checkbox
                      v-model="dia.selected"
                      :disabled="dia.inhabil"
                      :label="formatDate(dia.dia)"
                      dense
                      hide-details
                      readonly
                      class="py-0 my-0"
                    ></v-checkbox>
                  </span>
                </v-col>
                <v-col cols="4">
                  <span v-for="(dia, index) in dias" :key="index">
                    <v-checkbox
                      v-model="dia.selected"
                      :disabled="dia.inhabil"
                      :label="formatDate(dia.dia)"
                      dense
                      hide-details
                      class="py-0 my-0"
                      @change="updateDiasPendientes(index)"
                    ></v-checkbox>
                  </span>
                </v-col>
                <v-col cols="4">
                  <v-row v-if="dias.length" justify="center" class="mt-8">
                    <v-col cols="12" class="text-center">
                      <div>Dias disponibles:</div>
                      <div class="text-h5 text-center" :class="textColor">{{diasPdtes}}</div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-row justify="center">
                <v-btn small text color="primary" outlined :disabled="disabledSave" @click="saveVacaciones()">
                  <v-icon left small>mdi-content-save-outline</v-icon>
                  Guardar
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <dialog-message :show.sync="showDialog" :color="colorDlg" :title="titleDlg">
      {{ mensaje }}
    </dialog-message>
  </div>
</template>

<script>
import axios from "axios";
import DialogMessage from "@/components/dialogs/DialogMessage.vue";
import BuscarEmpleado from '@/components/dialogs/BuscarEmpleado.vue';
//import dateUtils from '@/utils/DateUtils.js';

export default {
  components: {
    BuscarEmpleado,
    DialogMessage
  },
  data() {
    return {
      ejercicio: null,
      empSearch: null,
      dias: [],
      diasOri: [],
      diasPdtes: 0,
      overlay: false,
      modified: false,
      showDialog: false,
      showDlgMotivo: false,
      mensaje: "Mensaje",
      colorDlg: 'primary',
      titleDlg: "Aviso"
    }
  },
  watch: {
    empSearch() {
      if (this.empSearch) {
        this.getVacaciones();
      }
    }
  },
  computed: {
    textColor() {
      return this.diasPdtes < 0? "red--text": "";
    },
    disabledSave() {
      return !this.modified || this.diasPdtes < 0;
    }
  },
  methods: {
    getVacaciones() {
      this.overlay = true;
      let self = this;
      let numEmp = this.empSearch.numEmpleado;
      axios.get(`/modivac/${numEmp}/${this.ejercicio}`)
      .then(response => {
        self.diasPdtes = response.data.diasPendientes;
        self.dias = response.data.dias;
        self.diasOri = self.dias.map(d => {
          let copia = {...d};
          return copia;
        });
        self.overlay = false;
      })
      .catch(error =>{
        self.overlay = false;
        if (error.response) {
          self.showError(error.response.data.mensaje);
        } else {
          console.log(error);
          self.showError("Error en la petición");
        }
      });
    },
    saveVacaciones() {
      let self = this;
      this.overlay = true;
      let numEmp = this.empSearch.numEmpleado;
      axios.put(`/modivac/${numEmp}/${this.ejercicio}`, this.dias)
      .then(response => {
        /*self.diasOri = self.dias.map(d => {
          let copia = {...d};
          return copia;
        });*/
        self.modified = false;
        self.overlay = false;
        this.showInfo(response.data.mensaje);
        self.getVacaciones();
      })
      .catch(error =>{
        self.overlay = false;
        if (error.response) {
          console.log(error);
          self.showError(error.response.data.mensaje);
        } else {
          console.log(error);
          self.showError("Error en la petición");
        }
      });
    },
    formatDate(strISODate) {
      if (!strISODate) return null;

      const [year, month, day] = strISODate.substring(0, 10).split('-')
      return `${day}/${month}/${year}`
    },
    updateDiasPendientes(index) {
      let dia = this.dias[index];
      if (dia.selected) {
        this.diasPdtes--;
      } else {
        this.diasPdtes++;
      }
      let modi = false;
      let ind = 0;
      while (!modi && ind < this.diasOri.length) {
        modi = this.diasOri[ind].selected !== this.dias[ind].selected;
        ind++;
      }
      this.modified = modi;
    },
    showInfo: function (message) {
      this.mensaje = message;
      this.colorDlg = "primary";
      this.titleDlg = "Aviso",
      this.showDialog = true;
    },
    showError: function (message) {
      this.mensaje = message;
      this.colorDlg = "error";
      this.titleDlg = "Error",
      this.showDialog = true;
    }
  },
  mounted: function() {
    let hoy = new Date();
    let year = hoy.getFullYear();
    let month = hoy.getMonth();
    this.ejercicio = month < 10? year- 1: year;
  }
}
</script>
